// extracted by mini-css-extract-plugin
module.exports = {"select":"TodoSelect_select__3mEj_"};